import { useEffect, useState } from 'react';
import { db, collection, addDoc } from '../../firebase';
import styled from 'styled-components';
import IconX from '../svg/IconX';

const MessageForm = ({ onMessageAdded, setActive }) => {
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [password, setPassword] = useState('');
  const [validation, setValidation] = useState(false);

  const handleChange = (value, setValue, maxLength) => {
    setValue(value.slice(0, maxLength));
  };

  const handleAddMessage = async (e) => {
    e.preventDefault();

    if (!validation) return;

    try {
      await addDoc(collection(db, 'weddingMessages'), {
        name,
        message,
        password,
        date: Date.now(),
      });
      onMessageAdded();
      setName('');
      setMessage('');
      setPassword('');
      setActive(false);
    } catch (error) {
      console.error('메시지 저장 오류:', error);
    }
  };

  useEffect(() => {
    if (!!name.trim() && !!message.trim() && !!password.trim()) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  }, [name, message, password]);

  return (
    <StyledArticle>
      <StyledDiv onClick={() => setActive(false)} />
      <StyledForm onSubmit={(e) => handleAddMessage(e)}>
        <h3>💌 축하 메시지</h3>
        <label htmlFor="message">To. 영준&유진</label>
        <StyledTextarea
          id="message"
          placeholder="축하 메시지를 입력하세요!(최대 100자)"
          value={message}
          onChange={(e) => handleChange(e.target.value, setMessage, 100)}
        />
        <StyledLabel>
          From.
          <StyledInput
            type="text"
            placeholder="이름(최대 5자)"
            value={name}
            onChange={(e) => handleChange(e.target.value, setName, 5)}
          />
        </StyledLabel>
        <label htmlFor="password" className="a11y-hidden">
          비밀번호
        </label>
        <StyledPasswordInput
          id="password"
          type="password"
          placeholder="비밀번호(최대 8자)"
          value={password}
          onChange={(e) => handleChange(e.target.value, setPassword, 8)}
        />
        <StyledButton disabled={!validation}>메시지 남기기</StyledButton>
        <StyledCloseButton type="button" onClick={() => setActive(false)}>
          <IconX />
          <span className="a11y-hidden">닫기</span>
        </StyledCloseButton>
      </StyledForm>
    </StyledArticle>
  );
};

const StyledArticle = styled.article`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
`;

const StyledDiv = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
`;

const StyledForm = styled.form`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 80%;
  max-width: 40rem;
  background: var(--background);
  border-radius: 1.5rem;
  padding: 2rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  line-height: 1.6rem;
  font-weight: 400;

  & > h3 {
    font-size: 1.6rem;
    text-align: center;
    margin-bottom: 1rem;
  }

  input,
  textarea {
    padding: 1rem;
    border: 1px solid var(--grayLv2);
    border-radius: 0.8rem;
    box-sizing: border-box;

    &::placeholder {
      font-family: var(--pretendard);
      color: var(--grayLv3);
      font-size: 1.4rem;
      line-height: 1.6rem;
    }
  }

  input {
    width: 15rem;
  }
`;

const StyledLabel = styled.label`
  margin-left: auto;
`;

const StyledInput = styled.input`
  margin-left: 0.5rem;
`;

const StyledTextarea = styled.textarea`
  resize: none;
  height: 10rem;
`;

const StyledPasswordInput = styled.input`
  margin-left: auto;
`;

const StyledButton = styled.button`
  display: block;
  margin-top: 1rem;
  padding: 1rem;
  background-color: var(--primary);
  border-radius: 5px;
  font-family: var(--pretendard);
  font-weight: 600;
  color: var(--background);

  &:disabled {
    background-color: var(--grayLv2);
    color: var(--grayLv3);
  }
`;

const StyledCloseButton = styled.button`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;

  svg {
    width: 2rem;
    height: 2rem;
  }

  path {
    fill: var(--grayLv3);
  }
`;

export default MessageForm;
